import { useEffect, useState } from 'react';

type ShareDialogProps = {
  open: boolean;
  title: string;
  onClose: () => void;
};

const shareChannels = [
  { key: 'wechat', label: '微信', icon: 'ri-wechat-fill', hint: '打开微信扫一扫，分享给好友' },
  { key: 'weibo', label: '微博', icon: 'ri-weibo-fill', hint: '已生成分享文案，可粘贴至微博发布' },
  { key: 'link', label: '复制链接', icon: 'ri-link', hint: '页面链接已复制到剪贴板' },
  { key: 'poster', label: '生成海报', icon: 'ri-image-line', hint: '海报功能为演示状态，暂不生成图片' },
];

export default function ShareDialog({ open, title, onClose }: ShareDialogProps) {
  const [feedback, setFeedback] = useState('');

  useEffect(() => {
    if (!open) setFeedback('');
  }, [open]);

  if (!open) return null;

  const handleChannel = async (key: string, hint: string) => {
    if (key === 'link') {
      try {
        await navigator.clipboard.writeText(window.location.href);
        setFeedback('页面链接已复制，可粘贴分享给好友');
      } catch {
        setFeedback('浏览器未授权复制，请手动复制地址栏链接');
      }
      return;
    }
    setFeedback(hint);
  };

  return (
    <div className="fixed inset-0 z-[90] flex items-end justify-center bg-background-950/80 p-0 backdrop-blur-sm sm:items-center sm:p-6">
      <button type="button" aria-label="关闭分享弹窗" className="absolute inset-0 cursor-pointer" onClick={onClose} />
      <div className="animate-fade-up relative w-full max-w-md rounded-t-xl border border-background-700 bg-background-900 p-6 sm:rounded-lg">
        <div className="flex items-start justify-between gap-4">
          <div className="min-w-0">
            <h3 className="text-base font-semibold text-foreground-50">分享这条内容</h3>
            <p className="mt-1 truncate text-xs text-foreground-500">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md text-foreground-400 transition-colors hover:bg-background-800 hover:text-foreground-100"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        <div className="mt-6 grid grid-cols-4 gap-2">
          {shareChannels.map((channel) => (
            <button
              key={channel.key}
              type="button"
              onClick={() => handleChannel(channel.key, channel.hint)}
              className="flex cursor-pointer flex-col items-center gap-2 rounded-lg border border-background-800 bg-background-950/60 px-1 py-3 text-[11px] text-foreground-300 transition-colors hover:border-primary-500 hover:text-accent-400"
            >
              <i className={`${channel.icon} text-lg`} />
              {channel.label}
            </button>
          ))}
        </div>

        <div className="mt-5 rounded-md border border-background-800 bg-background-950/70 px-3 py-2.5 text-xs leading-relaxed text-foreground-500">
          {feedback ? (
            <span className="text-accent-400">{feedback}</span>
          ) : (
            '分享功能为前端演示，不会向任何第三方平台发送数据。'
          )}
        </div>
      </div>
    </div>
  );
}